import { render, staticRenderFns } from "./live_set.vue?vue&type=template&id=a27d314c&scoped=true&"
import script from "./live_set.vue?vue&type=script&lang=js&"
export * from "./live_set.vue?vue&type=script&lang=js&"
import style0 from "./live_set.vue?vue&type=style&index=0&id=a27d314c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27d314c",
  null
  
)

export default component.exports